export default __webpack_public_path__ + "static/media/ebd.07cd99b0.jpg";